import React from 'react';
import { PhoneIcon, MailIcon, MapPinIcon } from 'lucide-react';
import { ScrollReveal } from '../components/ScrollReveal';
import { SEOHead } from '../components/SEOHead';
export function ContactPage() {
  return <div className="bg-viridia-black min-h-screen pt-24" data-id="element-1391" data-mp="srap83gnzlts">
      <SEOHead title="Contact Us | Book a Free Strategy Call | Viridia Analytics Phoenix" description="Book a free strategy call with Viridia Analytics. We'll review your current marketing, identify opportunities, and show you how to turn more leads into booked jobs. Call (623) 300-0708." canonical="/contact" keywords="contact Viridia Analytics, free strategy call, marketing consultation Phoenix, book a call, Phoenix marketing agency contact, marketing agency phoenix, AI marketing agency phoenix" data-id="element-1392" data-mp="xpcjzlngd9l3" />
      {/* HERO SECTION */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto text-center" data-id="element-1393" data-mp="1leos0i71nblt">
        <ScrollReveal data-id="element-1394" data-mp="1qcqd18o15kzx">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-6 tracking-tight" data-id="element-1395" data-mp="1qg4bi5tkpa23">
            Book a strategy call - no pitch, just a real look at your leads
          </h1>
          <p className="text-xl text-viridia font-medium max-w-2xl mx-auto mb-4" data-id="element-1396" data-mp="mwyz2d44dhl8">
            Our clients generated 380+ leads and 57 AI-booked estimates last
            month. Let us show you what that could look like for your business.
          </p>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-1397" data-mp="822hvaec1jw0">
            Booking an appointment is fast and easy
          </p>
        </ScrollReveal>
      </section>

      {/* MAIN CONTENT - BOOKING & EXPECTATIONS */}
      <section className="py-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-1398" data-mp="3vfocccykbbp5">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8" data-id="element-1399" data-mp="3qgla109yvjkv">
          {/* Left Column: What to Expect */}
          <ScrollReveal direction="right" className="lg:col-span-5" data-id="element-1400" data-mp="3lfe313fneof9">
            <div className="bg-viridia-surface rounded-2xl p-8 border border-gray-800 h-full" data-id="element-1401" data-mp="3gh47grq0hlt4">
              <h2 className="text-2xl font-bold text-white mb-8" data-id="element-1402" data-mp="36tgyca7664y3">
                What Happens on the Call
              </h2>

              <div className="space-y-8 mb-12" data-id="element-1403" data-mp="3btwc32vd5egl">
                <div className="flex" data-id="element-1404" data-mp="2xtbsi4hmjem1">
                  <div className="flex-shrink-0 mr-4" data-id="element-1405" data-mp="2xude32w9nji0">
                    <div className="w-8 h-8 rounded-full bg-viridia text-white flex items-center justify-center font-bold" data-id="element-1406" data-mp="31uxbm7kr4p4o">
                      1
                    </div>
                  </div>
                  <div data-id="element-1407" data-mp="3pmue382ba4t4">
                    <h3 className="text-lg font-semibold text-white mb-1" data-id="element-1408" data-mp="3uk47eystn0m8">
                      We review your current marketing
                    </h3>
                    <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1409" data-mp="3gq3jl03eqy0n">
                      We'll look at your ads, website, and follow-up process to
                      find quick wins.
                    </p>
                  </div>
                </div>

                <div className="flex" data-id="element-1410" data-mp="h5q1zgoourw1">
                  <div className="flex-shrink-0 mr-4" data-id="element-1411" data-mp="h6suft1nt2e2">
                    <div className="w-8 h-8 rounded-full bg-viridia text-white flex items-center justify-center font-bold" data-id="element-1412" data-mp="21u1yfl4uyu4p">
                      2
                    </div>
                  </div>
                  <div data-id="element-1413" data-mp="2bjv8uit9l37d">
                    <h3 className="text-lg font-semibold text-white mb-1" data-id="element-1414" data-mp="2bkdgebldn3ul">
                      We uncover growth opportunities
                    </h3>
                    <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1415" data-mp="1ivpmxsqh585y">
                      Based on your market and competition, we'll identify where
                      you're leaving money on the table.
                    </p>
                  </div>
                </div>

                <div className="flex" data-id="element-1416" data-mp="1nvc0626ayoer">
                  <div className="flex-shrink-0 mr-4" data-id="element-1417" data-mp="1nuan5s5q7rue">
                    <div className="w-8 h-8 rounded-full bg-viridia text-white flex items-center justify-center font-bold" data-id="element-1418" data-mp="349kb0zhpn9ak">
                      3
                    </div>
                  </div>
                  <div data-id="element-1419" data-mp="2zctz8ocxuzuy">
                    <h3 className="text-lg font-semibold text-white mb-1" data-id="element-1420" data-mp="18tx1svf8k4yx">
                      You get a custom game plan
                    </h3>
                    <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1421" data-mp="1dsqgusa68417">
                      Walk away with a clear roadmap - whether you work with us
                      or not. No obligation.
                    </p>
                  </div>
                </div>
              </div>

              <div className="pt-8 border-t border-gray-800" data-id="element-1422" data-mp="1rrq6a25icmyf">
                <div className="flex items-center mb-4" data-id="element-1423" data-mp="1wqsy2kwh8wog">
                  <div className="w-12 h-12 rounded-full bg-viridia-black border-2 border-viridia flex items-center justify-center mr-4" data-id="element-1424" data-mp="1wp852zpt9lsp">
                    <span className="text-white font-bold" data-id="element-1425" data-mp="25k614fo99eo9">KR</span>
                  </div>
                  <div data-id="element-1426" data-mp="2aizdu5vpx1nd">
                    <p className="text-white font-semibold" data-id="element-1427" data-mp="2ajsdkmw9eqw0">
                      Kevin Rogers - Viridia Analytics
                    </p>
                    <p className="text-viridia text-sm" data-id="element-1428" data-mp="2ffpx122tkdd0">
                      30 Minute Strategy Call
                    </p>
                  </div>
                </div>
                <div className="space-y-2 text-gray-400 text-sm ml-16" data-id="element-1429" data-mp="2klwgjhiu8ntm">
                  <p className="flex items-center" data-id="element-1430" data-mp="2fmt8do7ka1hf">
                    <PhoneIcon className="w-4 h-4 mr-2" data-id="element-1431" data-mp="2fpntlhyefqbw" /> (623) 300-0708
                  </p>
                  <p className="flex items-center" data-id="element-1432" data-mp="2bo2k86l2pu6g">
                    <MapPinIcon className="w-4 h-4 mr-2" data-id="element-1433" data-mp="38cic49bnofmq" /> Phoenix, Arizona
                  </p>
                </div>
              </div>
            </div>
          </ScrollReveal>

          {/* Right Column: Booking Widget */}
          <ScrollReveal direction="left" delay={0.2} className="lg:col-span-7" data-id="element-1434" data-mp="2ykw2uiivoqmm">
            <div className="bg-viridia-surface rounded-2xl border border-gray-800 overflow-hidden shadow-2xl h-full min-h-[900px]" data-id="element-1435" data-mp="2ujsoy1ke54o1">
              <iframe src="https://api.viridiaanalytics.com/widget/booking/hv5pIfS27zbJCMMGNnkJ" style={{
              width: '100%',
              height: '100%',
              minHeight: '900px',
              border: 'none'
            }} title="Book a Call" data-id="element-1436" data-mp="3r41dkbq17lmn" />
            </div>
          </ScrollReveal>
        </div>
      </section>

      {/* CONTACT INFO BAR */}
      <section className="py-12 bg-viridia-black border-t border-gray-800" data-id="element-1437" data-mp="1fn96rnrcuij4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1438" data-mp="11nzv91e3gclh">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center" data-id="element-1439" data-mp="11mop4ux6esr7">
            <div className="flex flex-col items-center" data-id="element-1440" data-mp="16nukz1m4uw4y">
              <div className="w-12 h-12 bg-viridia-surface rounded-full flex items-center justify-center mb-4 border border-gray-800" data-id="element-1441" data-mp="rq25uaki09ra">
                <PhoneIcon className="w-5 h-5 text-viridia" data-id="element-1442" data-mp="wpye4m08ancn" />
              </div>
              <p className="text-white font-medium" data-id="element-1443" data-mp="2m3lb66krswn5">(623) 300-0708</p>
            </div>
            <div className="flex flex-col items-center" data-id="element-1444" data-mp="2r2o8f4uidykk">
              <div className="w-12 h-12 bg-viridia-surface rounded-full flex items-center justify-center mb-4 border border-gray-800" data-id="element-1445" data-mp="2r24wq5vgc6ez">
                <MailIcon className="w-5 h-5 text-viridia" data-id="element-1446" data-mp="agrlmr8ngp59" />
              </div>
              <p className="text-white font-medium" data-id="element-1447" data-mp="aen77fd4k7qq">
                info@viridiaanalytics.com
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-1448" data-mp="ke5n9kpwz9di">
              <div className="w-12 h-12 bg-viridia-surface rounded-full flex items-center justify-center mb-4 border border-gray-800" data-id="element-1449" data-mp="kckv21r2o2it">
                <MapPinIcon className="w-5 h-5 text-viridia" data-id="element-1450" data-mp="u50aarazid00" />
              </div>
              <p className="text-white font-medium" data-id="element-1451" data-mp="1848bfpqpjv6u">Phoenix, Arizona</p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}